export default "__VITE_ASSET__bNCOevxc__"